import { render, staticRenderFns } from "./city-selected.vue?vue&type=template&id=071b3847&scoped=true&"
import script from "./city-selected.vue?vue&type=script&lang=js&"
export * from "./city-selected.vue?vue&type=script&lang=js&"
import style0 from "./city-selected.vue?vue&type=style&index=0&id=071b3847&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b3847",
  null
  
)

export default component.exports